import React, { useState } from 'react'
import 'date-fns'
import DateFnsUtils from '@date-io/date-fns'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers'
import {
    TextField,
    Button  , Dialog,DialogTitle, DialogContent,
     DialogActions
} from '@material-ui/core'
import {RTL} from '../Contact/Contact'
import { contact } from '../../constants'
import './Rdv.css'
export default function Rdv() {
    return (
        <div>
            {/* <Paper className="contact__card" variant="outlined">
                <div className="contact__card__left"> */}
                    <RTL>
                        <RdvForm />
                    </RTL>
                {/* </div>
                <div className="contact__card__right">
                    write some
                </div>
            </Paper> */}
        </div>
    )
}

function RdvForm() {
    const [selectedDate, setSelectedDate] = React.useState(new Date('2014-08-18T21:11:54'));
    const [fullname, setFullname] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

   
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const rdvSubmit = () => {
       
    }
    return (
        <div className='rdv' dir='rtl'>
            <h1>RDV</h1>
            <form className='card__shadow'>
                <label>{contact.f1}<span className='req'>*</span></label>
                <TextField
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    variant="outlined"
                    dir='rtl' />

                <label>{contact.f2}<span className='req'>*</span></label>
                <TextField
                    alue={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined" />

                <label>{contact.f3}<span className='req'>*</span></label>
                <TextField value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    variant="outlined" />

                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Date picker dialog"
                        format="MM/dd/yyyy"
                        value={selectedDate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                    />
                </MuiPickersUtilsProvider>

                <Button variant="contained" color="primary" onClick={rdvSubmit} >
                    {contact.action}
                </Button>
            </form>


        </div>
    )
}
